import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePriceLists } from '@/api/getPriceList';
import { usePostPaymentSubscriptionSession } from '@/features/auth/api/postPaymentSubscriptionSession';
import { calculateDiscountPercentage } from '@/utils/price';
import type { Price } from '@/types';

const findPriceByInterval = (
  prices: Price[] | undefined,
  interval: 'year' | 'month'
) => {
  return prices?.find((price) => price.recurringInterval === interval);
};

export const useSubscription = (
  promotion: string | null,
  isoCountryCode?: string
) => {
  const [isYearly, setIsYearly] = useState(true);
  const [error, setError] = useState<string>();
  const { mutate, isPending: isMutating } = usePostPaymentSubscriptionSession();
  const { t } = useTranslation();

  const { data: prices } = usePriceLists({ promotion, isoCountryCode });
  const yearlyPrice = findPriceByInterval(prices, 'year');
  const monthlyPrice = findPriceByInterval(prices, 'month');
  const currentPrice = isYearly ? yearlyPrice : monthlyPrice;

  const yearlyDiscountPercentage = calculateDiscountPercentage(
    monthlyPrice?.displayAmountMonthly || 0,
    yearlyPrice?.displayAmountMonthly || 0
  );

  const handleSubscribe = () => {
    if (!currentPrice) return;
    setError(undefined);

    mutate(
      {
        priceId: currentPrice.id,
        promotionCodeId: currentPrice.promotionCodeId,
        isoCountryCode,
      },
      {
        onSuccess: (data) => {
          window.location.href = data.url;
        },
        onError: (error) => {
          console.error(error);
          setError(
            t(
              'プランの選択に失敗しました。何度試しても解決しない場合はサポートに連絡いただけると幸いです。'
            )
          );
        },
      }
    );
  };

  return {
    isYearly,
    setIsYearly,
    error,
    currentPrice,
    yearlyDiscountPercentage,
    handleSubscribe,
    isMutating,
  };
};
